/**
 * "This window opened the project read-only" - the one flag the project store
 * needs from document presence (`layout/docPresence.ts`), kept in its own module
 * so the store can read it without importing the socket layer.
 *
 * Set when the operator takes "Open read-only" because the project is open on
 * another computer or window (OPBridge S350, operator 2026-11-03: "whenever any
 * document is open on two different computers, a warning must be displayed").
 * Cleared when the other copy closes, or by the operator.
 */

import { createSignal, type Accessor } from 'solid-js';

const [readOnlySig, setReadOnlySig] = createSignal(false);

/** True while this window holds the active project read-only. Reactive. */
export const projectReadOnly: Accessor<boolean> = readOnlySig;

export function setProjectReadOnly(on: boolean): void {
  setReadOnlySig(on);
}
